import axios from 'axios';
import { BACKEND_URL as backendUrl } from '@/config';

export const apiClient = axios.create({
  baseURL: `${backendUrl}/api/PortfolioDetails`,
});

export const baseApiClient = axios.create({
  baseURL: `${backendUrl}/api`,
});

export const getImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${backendUrl}${url.startsWith('/') ? '' : '/'}${url}`;
};
